/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2636__part-62
 */

"use strict"

import * as /* [auto-meaningful-name] */Module_33 from /* 33 */"./33"
import * as /* [auto-meaningful-name] */Module_6 from /* 6 */"./6"
import * as /* [auto-meaningful-name] */Module_10 from /* 10 */"./10/index"
import { useSelector } from /* 16 */"react-redux"
import /* [auto-meaningful-name] */React from /* 0 */"react"
import { memo, useState, useEffect } from /* 0 */"react"
import * as /* [auto-meaningful-name] */React1 from "react"
import * as /* [auto-meaningful-name] */Module_691 from /* 691 */"./691/index"
import * as /* [auto-meaningful-name] */Module_145 from /* 145 */"./145"
import * as /* [auto-meaningful-name] */Module_215 from /* 215 */"./215"
import * as /* [auto-meaningful-name] */Module_741 from /* 741 */"./741"
import /* [auto-meaningful-name] */Module_7411 from /* 741 */"./741"
var gh = memo(function (e) {
  var t = e.id
  var /* [auto-meaningful-name] */e$stage = e.stage
  var /* [auto-meaningful-name] */e$updateTimes = e.updateTimes
  var /* [auto-meaningful-name] */e$coordinateRatio = e.coordinateRatio
  var i = useState()
  var a = Module_10.a(i, 2)
  var s = a[0]
  var c = a[1]
  var l = useSelector(function (e) {
    return e.project.selectedWidgetId
  })
  useEffect(function () {
    if (l === t && e$stage && t) {
      var e = Module_33.Cb(t)
      c(Module_6.a({}, e))
    } else {
      c(undefined)
    }
  }, [t, l, e$stage, e$updateTimes])
  var u = (null === s || undefined === s ? undefined : s.parentId) ? Module_33.Cb(s.parentId) : undefined
  var d = (null === e$stage || undefined === e$stage ? undefined : e$stage.actors.get_actor(t)) || {}
  var /* [auto-meaningful-name] */d$value = d.value
  var /* [auto-meaningful-name] */d$is_error = d.is_error
  if (!s || !u || !d$is_error || !d$value || d$is_error(d$value)) {
    return null
  }
  var g = d$value
  var v = Math.max(g.get_width(), 54) / e$coordinateRatio
  var b = Math.max(g.get_height(), 54) / e$coordinateRatio
  var y = g.get_position()
  var E = g.get_center_position()
  var O = u.position.x + u.size.width / 2
  var w = u.position.y + u.size.height / 2
  var C = O + y.x / e$coordinateRatio
  var T = w - y.y / e$coordinateRatio
  var A = C - u.position.x
  var I = T - u.position.y
  var j = (E.x - y.x) / e$coordinateRatio
  var N = (y.y - E.y) / e$coordinateRatio
  var R = 3 / e$coordinateRatio
  var k = g.get_rotation()
  var x = Math.round(-180 * k / Math.PI)
  return React.createElement("div", {
    className: Module_7411.actorSelectedBox,
    style: {
      display: s.visible ? undefined : "none",
      position: "absolute",
      width: v,
      height: b,
      left: A,
      top: I,
      transformOrigin: "".concat(j, "px ").concat(N, "px"),
      transform: "rotate(".concat(x, "deg)"),
      zIndex: -1
    }
  }, React.createElement("div", {
    style: {
      position: "absolute",
      width: v,
      height: b,
      left: j,
      top: N,
      boxSizing: "content-box",
      pointerEvents: "none",
      borderWidth: R,
      borderColor: "white",
      borderStyle: "solid",
      transform: "translate(-50%, -50%)",
      filter: "drop-shadow(#7d7d7d 0px 0px 0.8px)"
    }
  }))
})
export { gh }
